import React, { useState } from "react";
import { Outlet, Route, Routes, useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import Footer from "components/Footer/Footer.js";
import Sidebar from "components/Sidebar/SidebarInterpreter";
import Header from "components/Navbars/InterpreterNavbar";
import { AppointmentRoutes } from "views-interpreters/AppointmentList";
import { AvailableRoutes } from "views-interpreters/AvailableJobs";
import { AssignedRoutes } from "views-interpreters/AssignedJobs";
import routesInterpreters from "routes-interpreter";
import { CompletedRoutes } from "views-interpreters/CompletedJobs";
import { loadRecaptchaScript } from "helpers/recaptcha";
import { GHOST_ADMIN_KEY, returnFromGhost, userSelector } from "slices/userSlice";

// Shown only while an admin is ghost-logged-in as this interpreter (the admin session
// is stashed under GHOST_ADMIN_KEY) — one click swaps the session back, no re-login.
function GhostBanner() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { user } = useSelector(userSelector);

  if (!localStorage.getItem(GHOST_ADMIN_KEY)) return null;

  const handleReturn = () => {
    dispatch(returnFromGhost((success) => {
      if (success) navigate('/interpreters');
    }));
  };

  return (
    <div style={{
      background: '#5e72e4', color: '#fff', padding: '8px 16px', textAlign: 'center',
      position: 'sticky', top: 0, zIndex: 1050, fontSize: '14px',
    }}>
      Ghost mode — you are viewing the portal as <strong>{user?.user?.name}</strong>.
      <button type="button" onClick={handleReturn} style={{
        marginLeft: '12px', background: '#fff', color: '#5e72e4', border: 'none',
        borderRadius: '4px', padding: '3px 12px', cursor: 'pointer', fontWeight: 600,
      }}>
        Return to Admin
      </button>
    </div>
  );
}

function InterpreterLayout(props) {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const mainPanel = React.useRef();
  const location = useLocation();

  React.useEffect(() => {
    mainPanel.current.scrollTop = 0;
    document.scrollingElement.scrollTop = 0;
  }, [location]);

  // Interpreter-portal submissions are reCAPTCHA-protected, so load the script (and its
  // badge) once when the portal mounts rather than on the first submit.
  React.useEffect(() => {
    loadRecaptchaScript();
  }, []);

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  return (
    <div className="wrapper">
      <Sidebar
        {...props}
        routes={routesInterpreters}
        isSidebarOpen={isSidebarOpen}
        toggleSidebar={toggleSidebar}
      />
      <div className={`main-panel ${isSidebarOpen ? "collaped" : ""}`} ref={mainPanel}>
        <GhostBanner />
        <Header {...props} toggleSidebar={toggleSidebar} />
        <Routes>
          {routesInterpreters.map((prop, key) => {
            return (
              <Route
                path={prop.path}
                element={prop.component}
                key={key}
              />
            );
          })}

          <Route path="/appointments/*" element={<AppointmentRoutes />} />
          <Route path="/available-jobs/*" element={<AvailableRoutes />} />
          <Route path="/assigned-jobs/*" element={<AssignedRoutes />} />
          <Route path="/completed-jobs/*" element={<CompletedRoutes />} />
        </Routes>
        <Footer fluid />
      </div>
      <Outlet />
    </div>
  );
}

export default InterpreterLayout;
